module.exports = __webpack_public_path__ + "static/media/pandaria-4.b784fb02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pandaria-4.jpg
// module id = 106
// module chunks = 0